var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/gift-card/product-gift-card-emailAddress.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "product/templates/gift-card/product-gift-card-emailAddress.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_4 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_4);
if(t_1.hasOwnProperty("hasErrors")) {
var t_5 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_5);
if(t_1.hasOwnProperty("validatedField")) {
var t_6 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_6);
output += "<div class=\"c-form__field ";
output += runtime.suppressValue((lineno = 3, colno = 36, runtime.callWrap(t_5, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"validation")),"messages")),"emailAddress")])), env.opts.autoescape);
output += " is-required\">\n\n    <label class=\"c-form__label c-form__label--required\" for=\"recipient-email\" data-qa-recipient-email-address-label>";
output += runtime.suppressValue((lineno = 5, colno = 119, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_gift-card-email"])), env.opts.autoescape);
output += "</label>\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "quickshop") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"product")),"productControls")),"validation")),"values")),"emailAddress")) {
output += "\n        ";
var t_7;
t_7 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"product")),"productControls")),"validation")),"values")),"emailAddress");
frame.set("recipientEmailAddress", t_7, true);
if(frame.topLevel) {
context.setVariable("recipientEmailAddress", t_7);
}
if(frame.topLevel) {
context.addExport("recipientEmailAddress", t_7);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_8;
t_8 = "";
frame.set("recipientEmailAddress", t_8, true);
if(frame.topLevel) {
context.setVariable("recipientEmailAddress", t_8);
}
if(frame.topLevel) {
context.addExport("recipientEmailAddress", t_8);
}
output += "\n    ";
;
}
output += "\n\n    <input required class=\"c-form__text\" type=\"email\" name=\"emailAddress\" id=\"recipient-email\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "recipientEmailAddress"), env.opts.autoescape);
output += "\" placeholder=\"";
output += runtime.suppressValue((lineno = 13, colno = 141, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_gc-email"])), env.opts.autoescape);
output += "\" data-qa-recipient-email-address ";
output += runtime.suppressValue((lineno = 13, colno = 210, runtime.callWrap(t_6, "validatedField", context, ["ERROR_PRODUCT_GIFTCARD_REQUIRED_RECIPIENT_EMAIL"])), env.opts.autoescape);
output += "\n        aria-describedby=\"recipient-email_error\"/>\n\n    ";
output += runtime.suppressValue((lineno = 16, colno = 23, runtime.callWrap(t_4, "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"validation")),"messages")),"emailAddress"),runtime.makeKeywordArgs({"id": "recipient-email"})])), env.opts.autoescape);
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/gift-card/product-gift-card-emailAddress.j2"] , dependencies)